import {ls} from "@/CultureService";
import {ResultError} from "@/api-client";
import _ from "underscore";

export default {
    labelIdle: `${ls.Components_Files_Text_DragFilesHereOr} <span class="filepond--label-action">${ls.Components_Files_Link_Browse}</span>`,
    labelInvalidField: ls.Components_Files_Text_FieldContainsInvalidFiles,
    labelFileWaitingForSize: ls.Components_Files_Text_WaitingForSize,
    labelFileSizeNotAvailable: ls.Components_Files_Text_SizeNotAvailable,
    labelFileLoading: ls.Components_Files_Text_Loading,
    labelFileLoadError: ls.Components_Files_Text_ErrorDuringLoad,
    labelFileProcessing: ls.Components_Files_Text_Uploading,
    labelFileProcessingComplete: ls.Components_Files_Text_UploadingSuccess,
    labelFileProcessingAborted: ls.Components_Files_Text_UploadCancelled,
    // labelFileProcessingError: (error: { type: any, code: number, body: any }): string => {
    //     if (error.body instanceof ResultError)
    //         return error.body.messagesFlattened.join(", ");

    //     if (_.isString(error.body))
    //         return error.body;

    //     return ls.Components_Files_Text_ErrorDuringUpload;
    // },
    labelFileProcessingError:ls.Components_Files_Text_ErrorDuringUpload,
    labelFileProcessingRevertError: ls.Components_Files_Text_ErrorDuringRevert,
    labelFileRemoveError: ls.Components_Files_Text_ErrorDuringRemove,
    labelTapToCancel: ls.Components_Files_Text_TapToCancel,
    labelTapToRetry: ls.Components_Files_Text_TapToRetry,
    labelTapToUndo: ls.Components_Files_Text_TapToUndo,
    labelButtonRemoveItem: ls.Global_Button_Remove,
    labelButtonAbortItemLoad: ls.Global_Button_Cancel,
    labelButtonRetryItemLoad: ls.Components_Files_Button_Retry,
    labelButtonAbortItemProcessing: ls.Global_Button_Cancel,
    labelButtonUndoItemProcessing: ls.Components_Files_Button_Undo,
    labelButtonRetryItemProcessing: ls.Components_Files_Button_Retry,
    labelButtonProcessItem: ls.Components_Files_Button_Upload,
    labelMaxFileSizeExceeded: ls.Components_Files_Text_FileIsTooLarge,
    labelMaxFileSize: ls.Components_Files_Text_MaximumFileSizeIs,
    labelMaxTotalFileSizeExceeded: ls.Components_Files_Text_MaximumTotalSizeExceeded,
    labelMaxTotalFileSize: ls.Components_Files_Text_MaximumTotalSizeIs,
    labelFileTypeNotAllowed: ls.Components_Files_Text_InvalidFileType,
    fileValidateTypeLabelExpectedTypes: ls.Components_Files_Text_ExpectedTypes,
    imageValidateSizeLabelFormatError: ls.Components_Files_Text_InvalidImageType,
    imageValidateSizeLabelImageSizeTooSmall: ls.Components_Files_Text_ImageIsTooSmall,
    imageValidateSizeLabelImageSizeTooBig: ls.Components_Files_Text_ImageIsTooBig,
    imageValidateSizeLabelExpectedMinSize: ls.Components_Files_Text_MinimumSizeIs,
    imageValidateSizeLabelExpectedMaxSize: ls.Components_Files_Text_MaximumSizeIs,
    imageValidateSizeLabelImageResolutionTooLow: ls.Components_Files_Text_ResolutionIsTooLow,
    imageValidateSizeLabelImageResolutionTooHigh: ls.Components_Files_Text_ResolutionIsTooHigh,
    imageValidateSizeLabelExpectedMinResolution: ls.Components_Files_Text_MinimumResolutionIs,
    imageValidateSizeLabelExpectedMaxResolution: ls.Components_Files_Text_MaximumResolutionIs
};
